module.exports = __webpack_public_path__ + "assets/media/day1.b0b06646.mp3";